import { StringColumn } from 'baseui/data-table';
import { CustomDateColumn, EMPTY_STRING } from 'commons-ui';

export const COL_NAMES = {
	sno: 'sno',
	uniqueID: 'uniqueID',
	name: 'name',
	description: 'description',
	segmentsCount: 'segmentsCount',
	segments: 'segments',
	featureId: 'featureId',
	updatedBy: 'updatedBy',
	updatedAt: 'updatedAt',
	createdBy: 'createdBy',
	createdAt: 'createdAt'
};

export const columnConfigs = [
	StringColumn({
		title: 'Feature ID',
		minWidth: 200,
		maxWidth: 250,
		mapDataToValue: (data: any) => data[COL_NAMES.featureId] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Feature Name',
		minWidth: 200,
		maxWidth: 250,
		mapDataToValue: (data: any) => data[COL_NAMES.name] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Description',
		minWidth: 200,
		maxWidth: 250,
		mapDataToValue: (data: any) => data[COL_NAMES.description] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Segments Count',
		minWidth: 200,
		maxWidth: 250,
		mapDataToValue: (data: any) => data[COL_NAMES.segmentsCount]?.toString?.() || EMPTY_STRING
	}),
	StringColumn({
		title: 'Updated By',
		minWidth: 200,
		maxWidth: 250,
		mapDataToValue: (data: any) => data[COL_NAMES.updatedBy] || EMPTY_STRING
	}),
	CustomDateColumn({
		title: 'Updated At',
		maxWidth: 120,
		columnName: COL_NAMES.updatedAt
	}),
	StringColumn({
		title: 'Created By',
		minWidth: 200,
		maxWidth: 250,
		mapDataToValue: (data: any) => data[COL_NAMES.createdBy] || EMPTY_STRING
	}),
	CustomDateColumn({
		title: 'Created At',
		maxWidth: 120,
		columnName: COL_NAMES.createdAt
	})
];

export const DEFAULT_CONFIG = {
	pageDetails: {
		pageNo: 1,
		pageSize: 20
	}
};
